import styled from 'styled-components';

export const StyledEcoLabel = styled.img`
	margin-top: 12px;
	width: 50px;
	height: 50px;
`;
